import React from "react";
import LayoutPagePublications from "../../src/layout/pages/publications";
import { CATEGORIES } from "../../src/configs/categories";
import { Categorie } from "@/types/categorie";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { PagedItems } from "@/types/contenu";
import { Viewport } from "@/types/enum";
import { SERVER_SIDE_CACHE_HEADER } from "@/configs/cache";

type ArticlesApprendreProps = {
    data: Categorie[];
    viewport: Viewport;
};

const ArticlesApprendre = ({ data, viewport }: ArticlesApprendreProps) => (
    <LayoutPagePublications
        contenu={data}
        viewport={viewport}
        boutonTitle="Voir tous les articles"
        parentId={CATEGORIES.APPRENDRE}
        title="Apprendre"
    />
);

export const getServerSideProps = (async ({ res, query }: GetServerSidePropsContext) => {
    const api = process.env.SERVER_API_URL;

    res.setHeader("Cache-Control", SERVER_SIDE_CACHE_HEADER);

    const response = await fetch(`${api}/v1/categories/type/publication`);
    const viewport = query["viewport"] || "desktop";

    if (response.status === 404) {
        return {
            notFound: true,
        };
    }

    const json: PagedItems<Categorie> = await response.json();

    return {
        props: {
            data: json.items,
            viewport: viewport as string,
        },
    };
}) satisfies GetServerSideProps;

export default ArticlesApprendre;
